import localScaleManager from "../../../helpers/LocalScaleManager";

export default class MiniTable {
  /**
   * @param scene {GameScene}
   * @param index {number}
   * @param miniTableToMoveDepth {number}
   */
  constructor(scene, index, miniTableToMoveDepth) {
    this.scene = scene;
    this.index = index;
    this.startDistance = 0;
    this.distanceBetween = 0;

    this.miniTable = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "mini-table-black")
      .setOrigin(0)
      .setAlpha(0.5)
      .setDepth(miniTableToMoveDepth - 1);

    // this.tableName = "NLH";
    this.tableName = this.scene.tableGames[index].tableGame.tableInfo.tableType;
    this.text = this.scene.add
      .bitmapText(0, 0, "HelveticaNeueTeal", this.tableName)
      .setDepth(miniTableToMoveDepth + 2);
    this.text.setData("width", this.text.width);
    this.text.setData("height", this.text.height);

    this.turnTable = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "mini-table-turn")
      .setOrigin(0)
      .setDepth(miniTableToMoveDepth + 1);

    if (this.scene.getVisitedTableGameIndex() !== this.index) {
      this.deactivate();
    }
    this.miniTable.setInteractive({ cursor: "pointer" });
    this.miniTable.on("pointerdown", () => {
      if (!this.scene.isSceneObjectsInteractive) return;
      const tablesNav = this.scene.header.tablesNav;
      if (this.scene.getVisitedTableGameIndex() !== this.index) {
        this.scene.changeVisitedTableGame(this.index);
        tablesNav.activateVisitedMiniTable();
      } else {
        tablesNav.menu.show();
      }
    });
    this.shape = this.scene.make.graphics();
    // this.shape = this.scene.add.graphics();
    this.turnTime = 30000;
    this.timerCounter = "";
    this.tableChildren = [this.miniTable, this.turnTable, this.text];
  }
  startTimer(time) {
    if (this.timerCounter) this.timerCounter.stop();

    this.turnTime = time;
    this.timerCounter = this.scene.tweens.addCounter({
      from: 0,
      to: 359,
      duration: this.turnTime,
      onUpdate: (tween) => {
        if (this.scene.header.tablesNav.isScrolling) return;
        let t = tween.getValue();
        this.shape.clear();
        // this.shape.fillStyle(0xffff00, 1);
        this.shape.setPosition(0, 0);
        this.shape.slice(
          this.turnTable.x + this.turnTable.displayWidth / 2,
          this.turnTable.y + this.turnTable.displayHeight / 2,
          this.turnTable.displayWidth / 2,
          Phaser.Math.DegToRad(270),
          Phaser.Math.DegToRad(270 + t),
          true
        );
        this.shape.fillPath();
      },
    });
  }
  clearTimer() {
    if (this.timerCounter) this.timerCounter.stop();
    this.shape.clear();
    this.shape.slice(
      this.turnTable.x + this.turnTable.displayWidth / 2,
      this.turnTable.y + this.turnTable.displayHeight / 2,
      this.turnTable.displayWidth / 2,
      Phaser.Math.DegToRad(270),
      Phaser.Math.DegToRad(270),
      true
    );
    this.shape.fillPath();
  }
  deactivate() {
    // this.miniTable.setFrame("mini-table-black", false, false);
    // this.miniTable.setTexture("mini-table-black");
    this.text.setAlpha(0.5);
    if (this.scene.header?.tablesNav) this.scene.header.tablesNav.menu.hide();
  }
  activate() {
    // this.miniTable.setFrame("mini-table", false, false);
    // this.miniTable.setTexture("mini-table");
    this.text.setAlpha(1);
  }
  remove() {
    this.miniTable.destroy();
    this.text.destroy();
    this.turnTable.destroy();
    this.shape.destroy();
  }
  positionControls(width, height) {
    const initX = this.scene.gameWidth * this.scene.getVisitedTableGameIndex();
    let tableSize = Math.min(width / 4.5, height / 4.5);
    // let tableSize = Math.min(width, height);
    let tableScale = localScaleManager.scaleSprite(
      this.miniTable,
      tableSize,
      tableSize,
      40,
      1,
      true
    );
    this.distanceBetween = this.miniTable.displayWidth / 15;
    this.startDistance = this.miniTable.displayWidth / 5;
    this.miniTable.setPosition(
      initX +
        this.startDistance +
        this.distanceBetween * this.index +
        this.index * this.miniTable.displayWidth,
      this.scene.header.menu.menuMargin
    );
    localScaleManager.scaleSpriteTo(this.turnTable, tableScale);

    this.turnTable.setPosition(this.miniTable.x, this.miniTable.y);

    this.textSize = this.miniTable.displayWidth / 1.1;
    // const textSize = this.displayWidth / 1.5 ;
    localScaleManager.scaleBitMapText(
      this.text,
      this.textSize,
      this.miniTable.displayHeight / 2,
      0,
      1,
      false
    );
    this.text.setPosition(
      this.miniTable.x + (this.miniTable.displayWidth - this.text.width) / 2,
      this.miniTable.y + (this.miniTable.displayHeight - this.text.height) / 2
    );

    // this.shape.setPosition(0, 0).setAlpha(.5);
    // this.shape.fillStyle(0xffff00, 1);
    this.shape.slice(
      this.turnTable.x + this.turnTable.displayWidth / 2,
      this.turnTable.y + this.turnTable.displayHeight / 2,
      this.turnTable.displayWidth / 2,
      Phaser.Math.DegToRad(270),
      Phaser.Math.DegToRad(270),
      true
    );

    this.mask = this.shape.createGeometryMask();

    this.turnTable.setMask(this.mask);
    this.shape.fillPath();
    // this.startTimer(80000);
  }
  reposition(width, height) {
    const initX = this.scene.gameWidth * this.scene.getVisitedTableGameIndex();
    this.distanceBetween = this.miniTable.displayWidth / 15;
    this.startDistance = this.miniTable.displayWidth / 5;
    this.miniTable.setPosition(
      initX +
        this.startDistance +
        this.distanceBetween * this.index +
        this.index * this.miniTable.displayWidth,
      this.scene.header.menu.menuMargin
    );
    this.turnTable.setPosition(this.miniTable.x, this.miniTable.y);

    this.text.setPosition(
      this.miniTable.x + (this.miniTable.displayWidth - this.text.width) / 2,
      this.miniTable.y + (this.miniTable.displayHeight - this.text.height) / 2
    );
    this.shape.slice(
      this.turnTable.x + this.turnTable.displayWidth / 2,
      this.turnTable.y + this.turnTable.displayHeight / 2,
      this.turnTable.displayWidth / 2,
      Phaser.Math.DegToRad(270),
      Phaser.Math.DegToRad(270),
      true
    );

    this.mask = this.shape.createGeometryMask();

    this.turnTable.setMask(this.mask);
    this.shape.fillPath();
  }
}
